<template>
    <div
            class="paint_mode_button"
            :class="{selected: menu_mode === CONST.MENU_MODE_CLIPPING}"
            @click="modeChange"
    >
        <span>家具にかかる製品を消す</span>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'
    import CONST from '../../assets/js/const'

    export default {
        name: "PaintModeButton",
        data: () => ({
            CONST
        }),
        computed: {
            ...mapState(["menu_mode"])
        },
        methods: {
            ...mapMutations(["setMenuMode", "setEditMode", "resetScale"]),
            modeChange() {
                if (this.menu_mode === CONST.MENU_MODE_CLIPPING) {
                    this.$root.$emit('restore_paint_config');
                    this.setMenuMode(CONST.MENU_MODE_DEFAULT);
                    this.setEditMode(CONST.EDIT_MODE_DEFAULT);
                } else {
                    this.setMenuMode(CONST.MENU_MODE_CLIPPING);
                    this.setEditMode(CONST.EDIT_MODE_CLIPPING);
                    this.resetScale();
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/define";
    svg{ vertical-align: middle }

    .paint_mode_button{
        @extend .clickable;
        user-select: none;
        display: flex;
        align-items: center;
        text-align: center;
        padding: 5px 10px;
        font-size: clamp(10px, 1vw, 18px);
        border: 1px solid #040404;
        border-radius: 3px;
        margin-right: 10px;
        transition: 0.3s;
        > *:not(:last-child) { margin-right: 0.25rem }
    }
    .paint_mode_button:hover,
    .paint_mode_button.selected{
        background-color: #040404;
        color: #fff;
        .icon{
            svg{
                .path{ fill: black }
            }
        }
    }
    @media (max-width: 739px) {
        .paint_mode_button{
            padding: 0px 10px;
        }
    }

</style>
